module.exports = __webpack_public_path__ + "static/media/9.0dfe7559.png";